import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { secondsToTimeText } from '../../../../../platform/ux/Advertiser/utils/secondsToTimeText';

const AdvertiserSessionsController = (props) => {
  const { signedURL, advertiser, setReport, setCreatives, creatives } = props;
  const [reportDataSummary, setReportData] = useState({
    byDates: [],
    signups: [],
    summary: {
      signups: 0,
    },
  });
  const [reportDataRawSummary, setReportRawData] = useState();
  const [reportDataSummaryLoading, setReportLoading] = useState(true);

  useEffect(() => {
    if (signedURL) {
      const s3UrlSummary = new URL(signedURL.getSignedURL);
      fetch(s3UrlSummary).then(async (response) => {
        if (response && response.ok) {
          try {
            await response.json().then((json) => {
              if (json) {
                let report = [];
                if (json.byDate) {
                  report.push({
                    name: 'Session - By Dates',
                    value: json.byDate,
                  });
                }
                if (json.sessionList) {
                  report.push({
                    name: 'Session List',
                    value: json.sessionList.map((s) => ({
                      'Session ID': s.sessionId,
                      'Start Time': s.sessionStart,
                      'End Time': s.sessionEnd,
                      'Duration (s)': secondsToTimeText(s.durationInSeconds),
                      'Page Views': s.pageViews,
                      'Landing Page': s.landingPage,
                      'Exit Page': s.landingPage,
                      Device: s.device,
                      'Attribution Method': Object.keys(s.attributionMethod)[0]
                        .toLowerCase()
                        .replace(/_/g, ' ') // Replace underscores with spaces
                        .replace(/\b\w/g, (c) => c.toUpperCase()), // Capitalize first letter of each word,
                      Journey: JSON.stringify(s.journey),
                    })),
                  });
                }
                setReport(report);
              }

              setReportData(json);
              setReportRawData(json);
              setReportLoading(false);
            });
          } catch (err) {
            console.log(err);
            setReportLoading(false);
          }
        } else {
          setReportLoading(false);
        }
      });
    } else {
      setReport([]);
      setReportLoading(false);
    }
  }, [creatives, setCreatives, setReport, signedURL]);

  const changeDatePicker = (dates) => {
    const datePickerStartDate = dates[0].format('YYYY-MM-DD');
    const datePickerEndDate = dates[1].format('YYYY-MM-DD');

    if (!reportDataRawSummary) {
      return;
    }

    const { byDate, sessionList } = reportDataRawSummary;

    const filteredByDates = byDate.filter(
      (date) =>
        moment(date.date).isSameOrBefore(datePickerEndDate) &&
        moment(date.date).isSameOrAfter(datePickerStartDate)
    );
    const filteredSessions = sessionList.filter(
      (sess) =>
        moment(sess.sessionStart).isSameOrAfter(datePickerStartDate, 'day') &&
        moment(sess.sessionStart).isSameOrBefore(datePickerEndDate, 'day')
    );

    let summary = {
      byDate: filteredByDates,
      deviceBreakdown: filteredSessions.reduce(
        (acc, session) => {
          if (session.device === 'Mobile') {
            acc.mobile += 1;
          } else if (session.device === 'Tablet') {
            acc.tablet += 1;
          } else if (session.device === 'Desktop') {
            acc.desktop += 1;
          }

          return acc;
        },
        {
          mobile: 0,
          tablet: 0,
          desktop: 0,
        }
      ),
      sessions: filteredSessions.length,
      sessionList: filteredSessions,
      ...filteredByDates.reduce(
        (acc, curr) => {
          acc.impressions += curr.attributedImpressions || 0;
          acc.totalSessionDuration += curr.durationInSeconds || 0;
          acc.totalPageViews += curr.pageViews || 0;
          acc.averageSessionDuration = acc.totalSessionDuration / filteredSessions.length || 0;
          acc.pagesPerSession = acc.totalPageViews / filteredSessions.length || 0;
          acc.totalImpressions += curr.totalImpressions || 0;
          return acc;
        },
        {
          impressions: 0,
          averageSessionDuration: 0,
          pagesPerSession: 0,
          totalImpressions: 0,
          totalSessionDuration: 0,
          totalPageViews: 0,
        }
      ),
    };

    let report = [];
    if (filteredByDates) {
      report.push({
        name: 'Session - By Dates',
        value: filteredByDates,
      });
    }
    if (filteredSessions) {
      report.push({
        name: 'Session List',
        value: filteredSessions.map((s) => ({
          'Session ID': s.sessionId,
          'Start Time': s.sessionStart,
          'End Time': s.sessionEnd,
          'Duration (s)': secondsToTimeText(s.durationInSeconds),
          'Page Views': s.pageViews,
          'Landing Page': s.landingPage,
          'Exit Page': s.landingPage,
          Device: s.device,
          'Attribution Method': Object.keys(s.attributionMethod)[0]
            .toLowerCase()
            .replace(/_/g, ' ') // Replace underscores with spaces
            .replace(/\b\w/g, (c) => c.toUpperCase()), // Capitalize first letter of each word,
          Journey: JSON.stringify(s.journey),
        })),
      });
    }
    setReport(report);

    setReportData(summary);
  };

  return React.cloneElement(props.children, {
    ...props.children.props,
    reportDataSummary,
    advertiser,
    reportDataSummaryLoading,
    changeDatePicker,
  });
};

export default AdvertiserSessionsController;
